import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const DEFAULT_LANG = 'zh'
const LOCALE_KEY = 'localeLanguage'

const locales = {
  zh: require('./zh.js'),
  'zh-TW': require('./zh-TW.js'),
  en: require('./en.js'),
}

const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
})

/**
 * 设置语言环境的函数
 * @param {string} lang - 要设置的语言代码，如果未提供则尝试从本地存储获取
 */
export const setup = lang => {
  // 如果没有提供语言参数，则从本地存储中获取之前保存的语言设置
  if (lang === undefined) {
    lang = window.localStorage.getItem(LOCALE_KEY)
    // 检查获取的语言是否在支持的语言列表中，如果不在则使用默认语言
    if (locales[lang] === undefined) {
      lang = DEFAULT_LANG
    }
  }
  // 将当前设置的语言保存到本地存储中
  window.localStorage.setItem(LOCALE_KEY, lang)

  // 移除所有语言相关的类名，确保只保留当前语言的类名
  Object.keys(locales).forEach(lang => {
    document.body.classList.remove(`lang-${lang}`)
  })
  // 为当前语言添加对应的类名
  document.body.classList.add(`lang-${lang}`)
  // 设置文档的lang属性，这对SEO和无障碍访问很重要
  document.body.setAttribute('lang', lang)

  // 更新Vue的国际化配置
  Vue.config.lang = lang
  // 更新i18n实例的语言设置
  i18n.locale = lang
}

// setup()
export default i18n
